import { Component, Inject, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { Environment, ENVIRONMENT } from "@qid/env";
import { Scanner } from '../../models/scanner';
import { ViewScannerComponent } from '../view-scanner/view-scanner.component';
import { ScannerApiService } from '../../services/scanner-api.service';
import { CollectionTemplate } from '../../../collection-template';
import { CommonModule } from '@angular/common';
import { TemplateQrViewComponent } from '../template-qr-view/template-qr-view.component';
import { register } from 'swiper/element/bundle';

register();

@Component({
    selector: 'scanner-slider',
    templateUrl: './scanner-slider.component.html',
    styleUrls: ['./scanner-slider.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        TemplateQrViewComponent
    ]
})
export class ScannerSliderComponent implements OnInit {

    @Input() baseUrl: string = this.env.collectUrl;
    public templates: CollectionTemplate[] = [];
    public scanners: Scanner[] = [];

    loading = false;

    constructor(
        private modalController: ModalController,
        private scannerService: ScannerApiService,
        @Inject(ENVIRONMENT) private env: Environment
    ) {
    }

    ngOnInit() {
        this.fetchScanner();
    }

    public async fetchScanner() {
        const res = await this.scannerService.readAll(null);
        if (res) {
            this.scanners = res;
        }
    }


    async viewScanner(scanner: Scanner) {
        const modal = await this.modalController.create({
            component: ViewScannerComponent,
            componentProps: {
                scanner: scanner
            }
        }
        )
        return modal.present();
    }

}
